<a
  [routerLink]="!disabled && route ? route : null"
  routerLinkActive="active"
  [queryParams]="navigationExtras?.queryParams"
  [queryParamsHandling]="navigationExtras?.queryParamsHandling"
  [replaceUrl]="navigationExtras?.replaceUrl"
  [skipLocationChange]="navigationExtras?.skipLocationChange"
  class="router-link {{ alignment }}-aligned"
  [ngClass]="[type, classNameButtonStyle]"
  [attr.disabled]="disabled ? 'disabled' : null"
  [attr.data-e2e-id]="e2eId"
  [attr.tabindex]="tabIndex"
  i2gTrackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  (click)="onClick($event)"
>
  <!-- if nothing was passed in through ng-content...-->
  <span
    *ngIf="content.childElementCount === 0"
    class="router-link-content standard-content"
  >
    <i2g-icon *ngIf="icon" class="icon" [icon]="icon"> </i2g-icon>

    <span
      class="label"
      [ngClass]="{ 'sr-text': hideLabel, 'word-wrap': wordWrap }"
      >{{ label }}</span
    >
  </span>

  <span #content class="router-link-content custom-content">
    <ng-content></ng-content>
  </span>
</a>
